/*
 * @Author: Christion.Young
 * @Date: 2021-01-13 16:29:40
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: 事件订阅发布
 */
const install = (Vue) => {
  const Bus = new Vue({
    methods: {
      emit(event, ...args) {
        this.$emit(event, ...args);
      },
      on(event, callback) {
        this.$on(event, callback);
      },
      off(event, callback) {
        this.$off(event, callback);
      },
    },
  });

  Vue.prototype.$bus = Bus;
};

export default install;
